export default __webpack_public_path__ + "static/production-1-98f66b47c935e668f255bc59d003b1b0.webp";